import { render, staticRenderFns } from "./ColorRadioV2.vue?vue&type=template&id=41b2b31f&scoped=true"
import script from "./ColorRadioV2.vue?vue&type=script&lang=js"
export * from "./ColorRadioV2.vue?vue&type=script&lang=js"
import style0 from "./ColorRadioV2.vue?vue&type=style&index=0&id=41b2b31f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b2b31f",
  null
  
)

export default component.exports